// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button__activity-indicator{left:50%;margin-left:-12px;margin-top:-12px;position:absolute;top:50%}`, "",{"version":3,"sources":["webpack://./src/components/Button/Button.scss"],"names":[],"mappings":"AAAA,4BACE,QAAA,CACA,iBAAA,CACA,gBAAA,CACA,iBAAA,CACA,OAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
